var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_689_3391",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.543701,
    y: 0.190918,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_689_3391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0168 16.7178L17.0706 15.664L13.2937 11.8868V7.19089H11.7937V12.4947L16.0168 16.7178ZM12.5454 21.6909C11.2314 21.6909 9.99638 21.4415 8.84025 20.9429C7.6841 20.4442 6.67842 19.7675 5.8232 18.9126C4.96797 18.0578 4.29091 17.0525 3.79203 15.8969C3.29314 14.7413 3.0437 13.5065 3.0437 12.1926C3.0437 10.8786 3.29303 9.6436 3.7917 8.48747C4.29037 7.33132 4.96712 6.32564 5.82195 5.47042C6.6768 4.61519 7.68204 3.93813 8.83768 3.43924C9.99329 2.94036 11.2281 2.69092 12.542 2.69092C13.8559 2.69092 15.091 2.94025 16.2471 3.43892C17.4033 3.93759 18.4089 4.61434 19.2642 5.46917C20.1194 6.32402 20.7964 7.32926 21.2953 8.48489C21.7942 9.64051 22.0437 10.8753 22.0437 12.1892C22.0437 13.5032 21.7943 14.7382 21.2957 15.8943C20.797 17.0505 20.1202 18.0562 19.2654 18.9114C18.4106 19.7666 17.4053 20.4437 16.2497 20.9425C15.0941 21.4414 13.8593 21.6909 12.5454 21.6909ZM12.5437 20.1909C14.7603 20.1909 16.6478 19.4117 18.2062 17.8534C19.7645 16.2951 20.5437 14.4076 20.5437 12.1909C20.5437 9.97423 19.7645 8.08673 18.2062 6.52839C16.6478 4.97006 14.7603 4.19089 12.5437 4.19089C10.327 4.19089 8.43951 4.97006 6.88118 6.52839C5.32284 8.08673 4.54368 9.97423 4.54368 12.1909C4.54368 14.4076 5.32284 16.2951 6.88118 17.8534C8.43951 19.4117 10.327 20.1909 12.5437 20.1909Z",
    fill: "#758494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2d9359b37d2a8bdc9de4e5c8eb5d9122.svg";
export { ForwardRef as ReactComponent };